import { Component } from '@angular/core';

@Component({
    selector: 'app-solicitacoes-especiais-bloqueio-assinatura',
    templateUrl: './bloqueio-assinatura.component.html',
    styleUrls: ['./bloqueio-assinatura.component.css']
})

export class SolicitacoesEspeciaisBloqueioAssinaturaComponent {
}
